import { create } from 'zustand';

const useDiaryStore = create((set) => ({
    posts: [],
    page: 1,
    hasMore: true,
    scrollPosition: 0,

    setPosts: (posts) => set({ posts }),
    addPosts: (newPosts) => set((state) => ({ posts: [...state.posts, ...newPosts] })),
    setPage: (page) => set({ page }),
    setHasMore: (hasMore) => set({ hasMore }),
    setScrollPosition: (position) => set({ scrollPosition: position }),

    // 상태 초기화 (필요 시 사용)
    reset: () => set({ posts: [], page: 1, hasMore: true, scrollPosition: 0 }),
}));

export default useDiaryStore;
